import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { T_IntegrationType } from './user.schema';

export type AttendeeInfo = {
  user_full_name: string;
  user_email: string;
  position: string;
  location: string;
  career_summary: string;
  linkedin_profile: string;
  profile_pic_url: string;
  fun_fact: string;
  confident: boolean;
  company_info?: {
    name: string;
    domain: string;
    company_linkedin: string;
    founded_year: string;
    annual_revenue: string;
    total_funding: string;
    location: string;
    industries: string;
    description: string;
    product_services: string;
    employees: string;
    website: string;
  };
  education_summary: string;
  icebreakers?: string[];
  lastInteraction?: {
    date: Date;
    userTimeZoneDate?: string;
    interactionType: T_IntegrationType;
  };
};

export type MeetingInfo = {
  id: string;
  meetingName: string;
  startAt: string;
  endAt: string;
  location: string;
  attendees: AttendeeInfo[];
  internalAttendees: string[];
  icebreakers: string[];
  isRecurringEvent: boolean;
};

export type MeetingInfoSummary = {
  summary: {
    event: string;
    summary: string;
  }[];
  meetings: MeetingInfo[];
};

export type EmailMeetingInfo = {
  summary: string;
  meeting: MeetingInfo;
};

const MeetingPrepSchema = new mongoose.Schema({
  user: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.USER },
  meetingId: { type: String },
  meetingName: { type: String },
  startAt: { type: Date },
  endAt: { type: Date },
  location: { type: String },
  summary: { type: String },
  attendees: { type: [mongoose.Schema.Types.Mixed] },
  externalAttendees: { type: [mongoose.Schema.Types.ObjectId], ref: EModelName.UserInfo },
  internalAttendees: { type: [String], default: [] },
  icebreakers: { type: [String] },
  isRecurringEvent: { type: Boolean },
  status: { type: String },
  created: { type: Date, default: Date.now() },
  isFake: { type: Boolean, default: false },
});

// Add the index
MeetingPrepSchema.index(
  {
    user: 1,
    meetingId: 1,
  },
  { unique: true }
);

export type T_MeetingPrepBase = InferSchemaType<typeof MeetingPrepSchema>;

// Extend the type to properly type attendees
export interface T_MeetingPrep extends Omit<T_MeetingPrepBase, 'attendees'> {
  attendees: AttendeeInfo[];
}

export type T_MeetingPrepDocument = T_MeetingPrep &
  Document & {
    _id: string;
  };

export { MeetingPrepSchema };
